import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'alumni-tab-2-part',
	standalone: true,
	templateUrl: './alumni-tab-2.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: [`./alumni-tab-2.part.scss`],
})
export class AlumniTab2Part {
}
